import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Producto/deleteProductoSeleccion`, method: 'POST', body: values, token: token})
}